import { useMutation, useQueryClient } from "react-query";

import axios, { AxiosError } from "axios";

import { REACT_APP_STICK_SCHEDULER_SERVICE_ADDRESS } from "../modals/constants";

export function useCalculateGeoStickJob() {
  const queryClient = useQueryClient();
  return useMutation<string, AxiosError, string>(
    async (jobId: string) => {
      const response = await axios.post(
        `${REACT_APP_STICK_SCHEDULER_SERVICE_ADDRESS}/job/${jobId}/calculate`
      );
      if (response.status !== 200) {
        throw new Error("Error creating access token");
      }

      return response.data;
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries("stickCalculationJobs");
      }
    }
  );
}
